<template>
  <div style="position: relative;">
    <!-- 线形图 -->
    <div
      ref="lineDom"
      class="echarts-line"
    />
    <!-- 空数据占位图 -->
    <el-empty
      v-if="!lineData.length"
      class="echarts-empty"
      description="暂无数据"
      :image-size="300"
    />
  </div>
</template>
<script>
import * as echarts from 'echarts/core';
import ResizeEvent from '@/utils/event/ResizeEvent';

export default {
  name: 'BaseLine',
  props: {
    // 线形图数据
    lineData: {
      type: Array,
      required: true,
    },
    // x坐标配置
    xAxis: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
    // y坐标配置
    yAxis: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
    // 配置选项
    options: {
      type: Object,
      required: false,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      // resize事件ID
      resizeEventId: null,
      echartInstance: null,
      // 初始配置
      echartOptions: {
        xAxis: this.xAxis,
        yAxis: this.yAxis,
        tooltip: {
          trigger: 'axis',
        },
        series: [
          {
            name: 'data：',
            data: this.lineData,
            type: 'line',
          },
        ],
      },
      // 空数据选项
      noDataLoadingOption: {
        text: '暂无数据',
        effect: 'bubble',
        effectOption: {
          effect: {
            n: 0,
          },
        },
      },
    };
  },
  beforeMount() {
    this.$nextTick(() => {
      this.init();
    });
  },
  mounted() {
    this.setResize();
  },
  created() {
    if (this.options) {
      this.echartOptions = this.options;
    }
  },
  unmounted() {
    if (!this.echartInstance) {
      return;
    }
    this.echartInstance.dispose();

    // 根据ID销毁监听事件
    ResizeEvent.useEvent().remove(this.resizeEventId);
  },
  methods: {
    // 初始化
    init(options) {
      const echartDom = this.$refs.lineDom;
      if (!echartDom) {
        return;
      }
      if (!this.echartInstance) {
        this.echartInstance = echarts.init(echartDom);
      }

      this.$nextTick(() => {
        if (options) {
          this.echartOptions = options;
        }

        this.echartInstance.clear(); // 清除旧画布 重新渲染
        this.echartInstance.setOption(this.lineData.length ? this.echartOptions : this.noDataLoadingOption);
      });
    },

    // 设置尺寸适配
    setResize() {
      this.$nextTick(() => {
        this.resizeEventId = ResizeEvent.useEvent().resize(() => {
          if (!this.echartInstance) {
            return;
          }
          setTimeout(() => {
            this.echartInstance.resize();
          }, 180);
        });
      });
    },
  },
};
</script>
<style scoped>
.echarts-line {
  width: 100%;
  height: 100%;
}
.echarts-empty {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
